import { faqData } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
            关于黑料爆料平台你可能会关心的问题。如果这里没有你想要的答案，欢迎通过投稿邮箱联系我们。
          </p>
        </div>

        <div className="space-y-4">
          {faqData.map((faq) => (
            <details
              key={faq.id}
              className="group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer hover:bg-background-100 transition-colors list-none">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className="w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100 group-open:bg-primary-100 transition-colors">
                  <i className="ri-arrow-down-s-line text-foreground-500 group-open:text-primary-500 transition-all group-open:rotate-180"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}